import Vue from 'vue'
import VueRouter from 'vue-router'

import toilet_list from "@/views/toilet_list.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'list',
    component: toilet_list
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
